<div
    class="tw-px-5 md:tw-px-20 tw-py-[1.5rem] md:tw-py-[3rem] tw-bg-accent-brown-extra-light"
>
    <div class="tw-block tw-relative tw-mb-10 tw-mt-5">
        <img
            class="tw-right-0 tw-top-[50%] -tw-translate-y-[50%] tw-absolute tw-cursor-pointer"
            [mat-dialog-close]="true"
            src="../../../../../assets/images/announcement-close.svg"
            alt="Announcement"
        />
    </div>
    <div
        class="tw-flex tw-items-center tw-relative tw-text-[22px] md:tw-text-[32px] tw-font-semibold"
    >
        {{ "FEEDBACK.FEEDBACK_TITLE" | translate }}
    </div>

    <form
        class="tw-bg-white tw-rounded-[24px] tw-py-2 tw-mt-5"
        [formGroup]="submitYoursForm"
        (ngSubmit)="onSubmitYours()"
    >
        <div class="tw-flex tw-flex-col md:tw-flex-row tw-px-5 tw-mt-5">
            <div
                class="tw-flex md:tw-hidden tw-items-center tw-justify-center tw-basis-[45%] md:tw-pl-[90px]"
            >
                <div
                    (click)="triggerFileInput()"
                    class="tw-flex tw-flex-col tw-min-h-[210px] tw-min-w-[210px] tw-items-center tw-justify-center tw-rounded-full tw-bg-accent-brown-extra-light"
                >
                    <img
                        *ngIf="photoPreview"
                        [src]="photoPreview"
                        alt="Uploaded Photo"
                        class="tw-w-full tw-h-full tw-object-cover tw-rounded-full"
                    />
                    <input
                        type="file"
                        #fileInput
                        style="display: none"
                        (change)="onPhotoUpload($event)"
                        accept="image/*"
                    />

                    <svg
                        *ngIf="!photoPreview"
                        width="44"
                        height="55"
                        viewBox="0 0 44 55"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M22.2603 29.5629C19.6741 29.5629 17.5004 28.6822 15.7391 26.9209C13.9778 25.1597 13.0972 22.9859 13.0972 20.3998C13.0972 17.8136 13.9778 15.6398 15.7391 13.8786C17.5004 12.1173 19.6741 11.2366 22.2603 11.2366C24.8465 11.2366 27.0202 12.1173 28.7815 13.8786C30.5428 15.6398 31.4234 17.8136 31.4234 20.3998C31.4234 22.9859 30.5428 25.1597 28.7815 26.9209C27.0202 28.6822 24.8465 29.5629 22.2603 29.5629ZM22.2603 25.5498C23.7764 25.5498 25.0137 25.0705 25.9724 24.1118C26.9311 23.1531 27.4104 21.9158 27.4104 20.3998C27.4104 18.8837 26.9311 17.6464 25.9724 16.6877C25.0137 15.729 23.7764 15.2497 22.2603 15.2497C20.7443 15.2497 19.5069 15.729 18.5483 16.6877C17.5896 17.6464 17.1102 18.8837 17.1102 20.3998C17.1102 21.9158 17.5896 23.1531 18.5483 24.1118C19.5069 25.0705 20.7443 25.5498 22.2603 25.5498ZM22.2603 54.2431C16.0178 52.6825 10.89 49.0596 6.87699 43.3744C2.86394 37.6893 0.857422 31.4579 0.857422 24.6803V8.76193L22.2603 0.73584L43.6632 8.76193V24.6803C43.6632 31.4579 41.6567 37.6893 37.6437 43.3744C33.6306 49.0596 28.5028 52.6825 22.2603 54.2431ZM22.2603 5.01642L4.87047 11.5711V24.6803C4.87047 27.4895 5.26062 30.176 6.04094 32.7399C6.82125 35.3037 7.92484 37.6781 9.3517 39.863C11.4028 38.7483 13.4874 37.9122 15.6054 37.3549C17.7234 36.7975 19.9417 36.5188 22.2603 36.5188C24.579 36.5188 26.7973 36.7975 28.9153 37.3549C31.0333 37.9122 33.1178 38.7483 35.1689 39.863C36.5958 37.6781 37.6994 35.3037 38.4797 32.7399C39.26 30.176 39.6502 27.4895 39.6502 24.6803V11.5711L22.2603 5.01642ZM22.2603 40.5319C20.5213 40.5319 18.7823 40.7548 17.0434 41.2007C15.3044 41.6466 13.5877 42.3154 11.8933 43.2072C13.3202 44.7678 14.9031 46.139 16.6421 47.3206C18.381 48.5022 20.2538 49.4274 22.2603 50.0963C24.2668 49.4274 26.1396 48.5022 27.8786 47.3206C29.6176 46.139 31.2005 44.7678 32.6273 43.2072C30.933 42.3154 29.2163 41.6466 27.4773 41.2007C25.7383 40.7548 23.9993 40.5319 22.2603 40.5319Z"
                            fill="#FF8819"
                        />
                    </svg>
                    <div class="tw-mt-5 tw-text-gray-400">Your photo</div>
                </div>
            </div>

            <div class="tw-flex tw-flex-col tw-basis-[55%]">
                <input-general-variant
                    class="tw-block tw-mt-10 tw-w-[100%]"
                    [mandatoryField]="true"
                    [label]="'Name'"
                    [placeHolder]="'Name here'"
                    [controlName]="'customerName'"
                    [errors]="
                        getErrors('customerName', 'FORM.USERNAME' | translate)
                    "
                ></input-general-variant>

                <input-general-variant
                    class="tw-block tw-mt-10 tw-w-[100%]"
                    [mandatoryField]="true"
                    [label]="'Position'"
                    [placeHolder]="'Position title'"
                    [controlName]="'customerTitle'"
                    [errors]="
                        getErrors('customerTitle', 'FORM.USERNAME' | translate)
                    "
                ></input-general-variant>

                <textarea-general-variant
                    class="tw-block tw-mt-10 tw-w-[100%]"
                    [mandatoryField]="true"
                    [label]="'Your Review'"
                    [controlName]="'testimonyDetail'"
                    [placeHolder]="'Type your review here'"
                    [errors]="
                        getErrors(
                            'testimonyDetail',
                            'FORM.USERNAME' | translate
                        )
                    "
                ></textarea-general-variant>
            </div>

            <div
                class="tw-hidden md:tw-flex tw-items-center tw-justify-center tw-basis-[45%] tw-pl-[90px]"
            >
                <div
                    (click)="triggerFileInput()"
                    class="tw-cursor-pointer tw-flex tw-flex-col tw-h-[210px] tw-w-[210px] tw-items-center tw-justify-center tw-rounded-full tw-bg-accent-brown-extra-light"
                >
                    <img
                        *ngIf="photoPreview"
                        [src]="photoPreview"
                        alt="Uploaded Photo"
                        class="tw-w-full tw-h-full tw-object-cover tw-rounded-full"
                    />
                    <input
                        type="file"
                        #fileInput
                        style="display: none"
                        (change)="onPhotoUpload($event)"
                        accept="image/*"
                    />

                    <svg
                        *ngIf="!photoPreview"
                        width="44"
                        height="55"
                        viewBox="0 0 44 55"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M22.2603 29.5629C19.6741 29.5629 17.5004 28.6822 15.7391 26.9209C13.9778 25.1597 13.0972 22.9859 13.0972 20.3998C13.0972 17.8136 13.9778 15.6398 15.7391 13.8786C17.5004 12.1173 19.6741 11.2366 22.2603 11.2366C24.8465 11.2366 27.0202 12.1173 28.7815 13.8786C30.5428 15.6398 31.4234 17.8136 31.4234 20.3998C31.4234 22.9859 30.5428 25.1597 28.7815 26.9209C27.0202 28.6822 24.8465 29.5629 22.2603 29.5629ZM22.2603 25.5498C23.7764 25.5498 25.0137 25.0705 25.9724 24.1118C26.9311 23.1531 27.4104 21.9158 27.4104 20.3998C27.4104 18.8837 26.9311 17.6464 25.9724 16.6877C25.0137 15.729 23.7764 15.2497 22.2603 15.2497C20.7443 15.2497 19.5069 15.729 18.5483 16.6877C17.5896 17.6464 17.1102 18.8837 17.1102 20.3998C17.1102 21.9158 17.5896 23.1531 18.5483 24.1118C19.5069 25.0705 20.7443 25.5498 22.2603 25.5498ZM22.2603 54.2431C16.0178 52.6825 10.89 49.0596 6.87699 43.3744C2.86394 37.6893 0.857422 31.4579 0.857422 24.6803V8.76193L22.2603 0.73584L43.6632 8.76193V24.6803C43.6632 31.4579 41.6567 37.6893 37.6437 43.3744C33.6306 49.0596 28.5028 52.6825 22.2603 54.2431ZM22.2603 5.01642L4.87047 11.5711V24.6803C4.87047 27.4895 5.26062 30.176 6.04094 32.7399C6.82125 35.3037 7.92484 37.6781 9.3517 39.863C11.4028 38.7483 13.4874 37.9122 15.6054 37.3549C17.7234 36.7975 19.9417 36.5188 22.2603 36.5188C24.579 36.5188 26.7973 36.7975 28.9153 37.3549C31.0333 37.9122 33.1178 38.7483 35.1689 39.863C36.5958 37.6781 37.6994 35.3037 38.4797 32.7399C39.26 30.176 39.6502 27.4895 39.6502 24.6803V11.5711L22.2603 5.01642ZM22.2603 40.5319C20.5213 40.5319 18.7823 40.7548 17.0434 41.2007C15.3044 41.6466 13.5877 42.3154 11.8933 43.2072C13.3202 44.7678 14.9031 46.139 16.6421 47.3206C18.381 48.5022 20.2538 49.4274 22.2603 50.0963C24.2668 49.4274 26.1396 48.5022 27.8786 47.3206C29.6176 46.139 31.2005 44.7678 32.6273 43.2072C30.933 42.3154 29.2163 41.6466 27.4773 41.2007C25.7383 40.7548 23.9993 40.5319 22.2603 40.5319Z"
                            fill="#FF8819"
                        />
                    </svg>
                    <div class="tw-mt-5 tw-text-gray-400">Your photo</div>
                    <div
                        class="tw-mt-5 tw-text-[#ff8819]"
                        *ngIf="
                            getErrors('pictureUrl', 'required' | translate)
                                .length > 0
                        "
                    >
                        {{ getErrors("pictureUrl", "required" | translate) }}
                    </div>
                </div>
            </div>
        </div>

        <div
            class="tw-mt-5 tw-px-5 md:tw-px-10 tw-py-3 tw-flex-col md:tw-flex-row tw-flex tw-gap-6 md:tw-gap-0 tw-justify-between tw-items-center"
        >
            <div class="tw-text-gray-400 tw-text-center md:tw-text-start">
                Kindly review your contents before submit
            </div>
            <button
                ga-event-id="customer_says_submit_button_hp_click"
                ga-event-category="Homepage Button"
                ga-event-label="Customer Says Submit Button"
                ga-track="track"
                class="tw-text-white tw-cursor-pointer tw-text-xl tw-py-[1.1rem] tw-whitespace-nowrap tw-rounded-[3rem] tw-px-[3rem] tw-min-w-[176px] 2 tw-bg-gradient-to-r tw-from-[#FFA53C] tw-to-[#FFC53C]"
            >
                {{ "COMMON.SUBMIT" | translate }}
            </button>
        </div>
    </form>
</div>
